import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { BreadcrumbService } from '../../breadcrumb.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FormsService } from '../../_services/api_v1/forms.service';
import { AsyncSubject, Observable } from 'rxjs';
import { MessageService } from 'primeng/components/common/messageservice';
import { Properties } from '../general/properties';
import { SelectItem } from 'primeng/api';
import { LoginService } from 'src/app/_handler/login.service';

interface SelectedFiles {
  name: string;
  file: any;
  base64?: string;
  url?: string;
}

@Component({
  selector: 'app-form-support',
  templateUrl: './form.support.component.html'
})
export class FormSupportComponent implements OnInit {
  clientName: string;
  properties: Properties = new Properties();
  urlAcademy = environment.URL_ACADEMY;
  nuevoUsuario: any;
  tipoRolesSelectItem: SelectItem[] = [{
    label: 'Erick Apolinario', value: 'EA'
  },
  {
    label: 'Andres Guillen', value: 'AG'
  },
  {
    label: 'Jessica Tapia', value: 'JT'
  },
  { 
    label: 'Lorena Oleas', value: 'LO'
  },
  {
    label: 'Evelyn Proaño', value: 'EP'
  },
  {
    label: 'Leonardo Rocha', value: 'LR'
  }];

  solType = [
    { label: 'Anulación de cotizaciones', value: 'Anulación de cotizaciones' },
    { label: 'Anulación de formulario de vinculación', value: 'Anulación de formulario de vinculación' },
    { label: 'Reenvío de formulario de vinculación', value: 'Reenvío de formulario de vinculación' },
    { label: 'Cambio de datos de formulario', value: 'Cambio de datos de formulario' },
    { label: 'Error en cotización', value: 'Error en cotización' },
    { label: 'Error de emisión de póliza', value: 'Error de emisión de póliza' },
    { label: 'Renovaciones', value: 'Renovaciones' },
    { label: 'Inspecciones', value: 'Inspecciones' },
    { label: 'Actualización de documentación', value: 'Actualización de documentación' },
    { label: 'Regularización de documentos', value: 'Regularización de documentos' },
  ]

  ticketForm = new FormGroup({
    clientName: new FormControl('', Validators.required),
    plate: new FormControl('', Validators.required),
    clientCi: new FormControl('', [Validators.required, Validators.minLength(4), Validators.pattern("[0-9]*")]),
    solType: new FormControl('', Validators.required),
    cotiNumber: new FormControl(''),
    policyNumber: new FormControl(''),
    comercialName: new FormControl(''),
    description: new FormControl('', Validators.required),
    evidence: new FormControl('', Validators.required)
  });

  constructor(
    private breadcrumbService: BreadcrumbService,
    private formService: FormsService,
    private loginService: LoginService,
    private messageService: MessageService
  ) { }

  get control() {
    return this.ticketForm.controls;
  }

  ngOnInit() {
    this.loadBreadCrum();
    if (!environment.production) {
      this.tipoRolesSelectItem.push(
        {label: 'TEST Milenia Idrovo', value: 'T-MI'}
      )
    }
  }

  toBase64(files: File[], selectedFiles: SelectedFiles[]): Observable<SelectedFiles[]> {
    const result = new AsyncSubject<SelectedFiles[]>();
    if (files.length) {
      Object.keys(files).forEach((file, i) => {
        const url = URL.createObjectURL(files[i]);
        const reader = new FileReader();
        reader.readAsDataURL(files[i]);
        reader.onload = (e) => {
          selectedFiles = selectedFiles.filter(f => f.name != files[i].name);
          selectedFiles.push({ name: files[i].name, file: files[i], base64: reader.result as string, url: url });
          result.next(selectedFiles);
          if (files.length === (i + 1)) {
            result.complete();
          }
        };
      });
      return result;
    } else {
      result.next([]);
      result.complete();
      return result;
    }
  }

  async onSubmit() {
    this.toBase64(this.ticketForm.controls.evidence.value, []).subscribe(async (res) => {
      const images = [];
      for (const val of res) {
        images.push({
          name: val.name,
          base64: val.base64.split(',')[1]
        });
      }
      try {
        const userInfo = this.loginService.getUserInfo();
        await this.formService.postApiGForm({
          ...this.ticketForm.value,
          'evidence': images,
          'brokerEmail': userInfo.email,
          'brokerName': userInfo.name,
          'type': 'Ticket_Form'
        });
        this.ticketForm.reset();
        this.messageService.add({
          severity: this.properties.messageTypeSucccess,
          summary: 'Tu requerimiento fue recibido',
          detail: 'Nuestro equipo de soporte ha recibido tu solicitud. Recibirás una respuesta vía correo electrónico en un plazo máximo de 8 horas.'
        });
      } catch (e) {
        this.messageService.add({ severity: 'error', summary: '', detail: '¡Error al generar ticket!' });
      }
    })

  }

  uploadEvidence(event) {
    if (this.ticketForm.controls.evidence.value != event.target.files && event.target.files.length > 0) {
      this.ticketForm.controls.evidence.setValue(event.target.files);
    }
  }

  loadBreadCrum() {
    this.breadcrumbService.setItems([
      { label: 'Inicio', routerLink: ['/home'] },
      { label: 'Soporte Aplicaciones Autos', routerLink: ['/ticketSupport'] }
    ]);
  }

}
